import { LOGO_URL } from "@/lib/api";
import { useT } from "@/context/ContentContext";

export default function Footer() {
  const t = useT();
  return (
    <footer className="border-t border-white/10 mt-24 relative grain">
      <div className="mx-auto max-w-7xl px-6 py-10 flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <img src={LOGO_URL} alt="" className="h-10 w-10 object-contain" />
          <div>
            <div className="font-display text-lg text-chrome">DAZZLIN' DYMES</div>
            <div className="text-[10px] uppercase tracking-[0.32em] text-white/40">{t("footer.tagline", "Est. With Sparkle")}</div>
          </div>
        </div>
        <div className="text-xs text-white/40 tracking-wider uppercase">
          © {new Date().getFullYear()} Dazzlin' Dymes Dance Team. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
